import script from "./NewsfeedCreatorSavedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedCreatorSavedTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__